import { useSearchParams } from "react-router-dom";

export const useAllQueryParams = (): Record<string, string> => {
  const [searchParams] = useSearchParams();

  const params: Record<string, string> = {};

  if (searchParams) {
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  return params;
};
